/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import queryString from "query-string";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";

import environment from "constants/apiConst";
import TbodyGroup from "../tables/TbodyGroup";
import { FormGroup } from "../forms/FormGroup";
import TableOrder from "components/Tables/TableOrder";
import { TTableGroup } from "../arrayRoles/Array_Rol";
import { __Group } from "request/configuration/__Roles";
import ConfigurationHeader from "../ConfigurationHeader";
import Pagination from "components/Pagination/Pagination";
import { FormShowGroup } from "../FormShow/FormShowGroup";
import { SectionContainerGene } from "styled/SectionContainer.styled";
import ConfigurationCRUDContext from "context/ConfigurationCRUDContext";
import { useSelector } from "react-redux";
import { useGlobalContext } from "context/GlobalContext";
import { useQuery } from "@tanstack/react-query";

export const Group = () => {
  const navigate = useNavigate();
  const { setRequestEdit, setRequestCreate, setRequestDelete, setFormEdit, setFormShow, update } =
    useContext(ConfigurationCRUDContext);
  const freeZone_id = useSelector((state) => state.auth.dataUser.token);
  const [currentPage, setCurrentPage] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [maxPage, setMaxPage] = useState(1);
  const location = useLocation();
  const { q = "" } = queryString.parse(location.search);

  const formGroupes = () => {
    return <FormGroup />;
  };

  const formShowGroup = () => {
    return <FormShowGroup />;
  };

  useEffect(() => {
    setFormEdit(formGroupes);
    setFormShow(formShowGroup);
    setRequestEdit(environment.GROUP_UPDATE);
    setRequestCreate(environment.GROUP_CREATE);
    setRequestDelete(environment.GROUP_DELETE);
  }, [q, update, page]);


  const { requestData } = useGlobalContext();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["configGroup", page, q, freeZone_id, update],
    queryFn: () => requestData({
      Endpoint: environment.GROUP_GET,
      pageParam: page,
      ...(q?.length !== 0 && { data: { search: q } }),
      PropertyBody: "sendJSONContentPOST",
    })
  })

  useEffect(() => {
    if (data?.data?.status?.code !== 200) return;
    if (data?.data?.status?.data?.last_page < page) setPage(1);
  }, [data?.data?.status?.data?.last_page])

  return (
    <>
      <SectionContainerGene>
        <ConfigurationHeader title="Grupo" />
        <TableOrder
          thead={TTableGroup}
          data={data?.data?.status?.code === 200 ? data?.data?.status?.data?.data : []}
          setData={setCurrentPage}
          loading={isLoading}
          tbodyData={TbodyGroup}
        />
        <Pagination page={page} setPage={setPage} maxPage={data?.data?.status?.code === 200 ? data?.data?.status?.data?.last_page : 1} loading={isLoading} />
      </SectionContainerGene>
    </>
  );
};
